import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';

import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';

@customElement('text-input')
export class TextInput extends connect(store)(LitElement) {

	@property({type: String})
	placeholder = '';

	@property({type: String})
	action = '';

	@property({type: Function})
	text = null;

	@property({type: String})
	title = 'Text';

	static styles = [
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.icon {
				width: 11px;
				height: 11px;
				padding: 5px;
				display: inline-block;
			}

			.icon svg {
				display: block;
				fill: currentColor
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}

			input {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: var(--color-background-widget);

				min-height: var(--height-widget);
				transition: background-color 0.4s, color 0.4s;
				padding: 0.5em 1em;
				line-height: 120%;
				margin: 0;
				border: 1px solid var(--color-widget-border);
				width: 100%;
				box-sizing: border-box;
				text-align: left;
			}

			.info {
				padding: 0.5rem;
				font-family: var(--font-family-light);
				color: var(--color-text-widget);
				font-size: 12px;
				opacity: 0.7;
			}

			.notSatisfied {
				border-left-color: var(--color-warn);
			}

			@media (max-width: 768px) {
				input {
					width: 50vw;
				}
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
	}
	setText(e) {
		const input = e.target;
		if (this.action) {
			store.dispatch(
				{
					type: this.action,
					payload: {
						text: input.value
					}
				}
			);
		}
	}
	isSatisfied() {
		return true;
	}
	render() {
		const s = store.getState();
		return html`
			<div>
				<div class="title">${this.title[this.lang]}</div>
				<input placeholder="${this.placeholder}" value="${this.text(s)}" @change=${this.setText} class="${classMap({notSatisfied: !this.isSatisfied()})}">
			</div>

		`;
	}
}
